import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoVisaPassport16 = t0 => {
  const $ = _c(11);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M6.33333 10.6667H9.66667M3.66667 13.6667H12.3333C12.7015 13.6667 13 13.3682 13 13V3.00001C13 2.63182 12.7015 2.33334 12.3333 2.33334H3.66667C3.29848 2.33334 3 2.63182 3 3.00001V13C3 13.3682 3.29848 13.6667 3.66667 13.6667Z" />;
    t3 = <path d="M8.07341 4.60706L8.54265 5.33025L9.37528 5.1068L9.26989 5.96242L10.0513 6.32645L9.42063 6.91415L9.78526 7.69533L8.92434 7.74011L8.70154 8.57291L8.01324 8.05383L7.30726 8.54857L7.11365 7.70851L6.25482 7.6337L6.64649 6.86573L6.03667 6.25638L6.83035 5.91984L6.75489 5.06106L7.57921 5.31343L8.07341 4.60706Z" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== iconColor) {
    t4 = <g stroke={iconColor} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">{t2}{t3}</g>;
    $[4] = iconColor;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <defs />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== ariaLabel || $[8] !== className || $[9] !== t4) {
    t6 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t4}{t5}</svg>;
    $[7] = ariaLabel;
    $[8] = className;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default IcoVisaPassport16;